import setFavicons from 'lib/utils/favicon';

export default {
  SET_WINDOW_SIZE(state) {
    state.WINDOW_SIZE = document.documentElement.clientWidth;
  },

  DEVICE_DETECT(state, { isIOS, isAndroid, isMobileOnly }) {
    state.IS_IOS = isIOS;
    state.IS_ANDROID = isAndroid;
    state.IS_MOBILE_ONLY = isMobileOnly;
  },

  SET_COMMISSION(state, commission) {
    state.COMMISSION = commission;
  },

  SET_TRANSACTION(state, transaction) {
    state.TRANSACTION = transaction;

    sessionStorage.setItem('paymentId', transaction.id);
    sessionStorage.setItem('passwordCard', transaction.externalDigitalContentCode);
    sessionStorage.setItem('accessToken', transaction.accessToken);
    sessionStorage.setItem('processToken', transaction.processToken);
  },

  SET_PROJECT(state, data) {
    state.PROJECT = data;
  },

  SET_TRANSACTION_KEY(state, key) {
    state.TRANSACTION_KEY = key;
  },

  SET_TRANSACTION_QUERY(state, query) {
    state.TRANSACTION_QUERY = query;
  },

  SET_DIGITAL_SELLING_FILE(state, file) {
    state.DIGITAL_SELLING_FILE = file;
  },

  CLEAR_ALL_STATE(state) {
    state.PROJECT = {};
    state.COMMISSION = null;
    state.TRANSACTION = {};
    state.TRANSACTION_KEY = '';
    state.TRANSACTION_QUERY = {};
    state.CRYPTO_TRANSACTION_LIST = [];
  },

  SET_APPLE_PAY_SESSION(state, session) {
    state.APPLE_PAY_SESSION = session;
  },

  SET_PAYMENT_TYPE(state, type) {
    state.PAYMENT_TYPE = type;
  },

  SET_LANGUAGE(state, language) {
    state.PROJECT_LOCALE.language = language;
  },

  SET_PROVIDER(state, data) {
    state.PROJECT.provider = data;
  },

  SET_PAYMENT_ORIGIN(state, payload) {
    state.PAYMENT_ORIGIN = payload;
  },

  SET_METADATA(state, metadata) {
    setFavicons(metadata.favicon);
  },

  CLEAR_CRYPTO_TRANSACTION_LIST(state) {
    state.CRYPTO_TRANSACTION_LIST = [];
  },

  UPDATE_CRYPTO_TRANSACTION_LIST(state, data) {
    console.log('UPDATE::CRYPTO::PAYMENT::LIST', data);
    state.CRYPTO_TRANSACTION_LIST.push(data);
  },
};
